<template>
  <div>
    <v-menu
      transition="slide-x-transition"
      bottom
      right>
      <v-btn
        color="teal darken-3"
        fab small block dark
        slot="activator"
      >
        <v-icon dark>arrow_drop_down</v-icon>
      </v-btn>
      <v-list>
        <v-list-tile
          @click="print(CSV_TYPE)">
          <v-list-tile-title>CSV</v-list-tile-title>
        </v-list-tile>
        <v-list-tile
          @click="print(PDF_TYPE)">
          <v-list-tile-title>PDF</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import Printer from '@/plugins/printer/Printer'
import http from '@/plugins/http';

export default {
  props: [ "schemaId" ],
  computed: {
    CSV_TYPE () {
      return Printer.CSV_TYPE;
    },
    PDF_TYPE () {
      return Printer.PDF_TYPE;
    }
  },
  data() {
    return {
      menu: false
    }
  },
  methods: {
    print (type) {
      this.$emit("proceeding", true)
      http.get('schema/' + this.schemaId).then(({ data }) => {
        let schema = data
        http.get('form/' + this.schemaId).then(response => {
          let printer = new Printer(schema, type)
          printer.export(response.data)
          this.$emit("proceeding", false)
        })
      })
    }
  }
}
</script>
